import React, {Fragment, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {getComunications} from "../comunication/datasource";
import {useApp} from "@src/utility/hooks/useApp";
import {getUserData} from "olympus-frontend/src/utility/Utils";
import {Alert, Button, Col, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import {ExternalLink} from "react-feather";

const querySelectorBadge = ".main-menu-content > .navigation.navigation-main > li[data-id='comunication_list'] .badge"


// Notification Web Socket handler trough AWS
// This is a component that must be used in accordance with:
// 		Config Option: appConfig.notificationEndPoint
// 		API: src/hermes/comunication/datasource.js
// 		Utils Function: src/hermes/components/utils.js (updateComunicationBadge)
// TODO: Set other tenants (appInfo.notificationEndPoint)
const AwsNotification = () => {

	const {i18n, t} = useTranslation()
	const authStorage = useSelector(state => state.auth)
	const {appInfo, loginAppInfo, setAppInfo} = useApp();

	const [responsiveMaxWidth, setResponsiveMaxWidth] = useState(() => {
		return window.innerWidth < 900
	});

	const handleResize = () => {
		setResponsiveMaxWidth(window.innerWidth < 900)
	}

	// Manage the css-js transition of the navbar respecting to the communication alert Badge
	const handleScroll = () => {
		const navbar = document.querySelector('.navbar-static .main-menu');
		const communicationBadge = document.querySelector('#communications-alert');

		if (communicationBadge) {
			const communicationBadgeTop = communicationBadge.getBoundingClientRect().top;
			if (communicationBadgeTop < 0) {
				navbar.style.top = `0px`;
			} else {
				navbar.style.top = `50px`;
			}
		}
	}

	const userData = getUserData()

	const initComunicationBadge = (newNotificationNr = 0) => {
		const querySelector = document.querySelector(querySelectorBadge)

		if (!querySelector) {
			console.warn("[Comunication WSocket] No Comunication badge found")
			return;
		}
		console.log("[Comunication WSocket] Updating notifications, length:", newNotificationNr)
		if (newNotificationNr > 0) {
			// Target the .main-menu-content > .navigation.navigation-main > li#comunication > .badge
			// Set it up to show and its text to the number of new notifications with DOM
			querySelector.style.display = "flex"
			if (newNotificationNr > 99)
				querySelector.innerText = "99+"
			else
				querySelector.innerText = newNotificationNr
		} else {
			// Target the .main-menu-content > .navigation.navigation-main > li#comunication > .badge
			// Set it to hide with DOM
			const querySelectorEl = document.querySelector(querySelectorBadge)
			if (querySelectorEl) {
				querySelectorEl.style.display = "none"
				querySelectorEl.innerText = "0"
			}
		}
	}

	const updateComunicationBadge =  (event) => {
		const querySelector = document.querySelector(querySelectorBadge)

		if (!querySelector) {
			console.log("[Comunication WSocket] No Comunication badge found")
			return;
		}
		console.log("[Comunication WSocket] Updating comunications...", event)

		toast.success(t("[WebSocket Message]", {text: event.communication_title}), {
			position: "bottom-right",
			autoClose: 2500,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		})

		// Target the .main-menu-content > .navigation.navigation-main > li#comunication > .badge
		// Set it up to show and its text to the number of new notifications with DOM
		let newNotificationNr = parseInt(querySelector.innerText) || 0
		newNotificationNr = newNotificationNr + 1

		querySelector.style.display = "flex"

		if (newNotificationNr > 99)
			querySelector.innerText = "99+"
		else
			querySelector.innerText = newNotificationNr
	}

	const updateComunicationPopup = (event) => {
        if (event.communication_priority === 'HIGH') {

			// Don't show up if there is another banned of update-cache (Since it goes first)
			const cacheCleaner = document.querySelector("#cache_warning");
			if (cacheCleaner)
				return;

            const communicationIdsString = document.querySelector("#communications-alert").getAttribute('communication_ids') || '';
            const communicationIds = communicationIdsString ? communicationIdsString.split(',') : [];

            communicationIds.push(event.communication_id);
            document.querySelector("#communications-alert").setAttribute('communication_ids', communicationIds.join(','));
            document.querySelector("#communications-alert").classList.remove("d-none");

			// Execute first time for showing badge
			handleScroll()
			// Adding scroll behaviour to navbar
			window.addEventListener('scroll', handleScroll)
        }
    };

	const onOpenConnection = async (event) => {
		console.log("[Comunication WSocket] Connection opened", event);
		// Must update first comunication by API
		const response = await getComunications(
			t,
			i18n,
			{},
			true,
			undefined,
			true
		)
		response.comunications.forEach((x) => {
			if (x.recipients.filter((y) => y.user.id === userData.id && (y.read_timestamp === undefined || y.read_timestamp === null)).length > 0) {
				x.to_read = true
			}
		})
		const newNotifications = response.comunications.filter((x) => x.to_read === true)
		initComunicationBadge(newNotifications.length)

		const highComunicationIds = newNotifications.filter((x) => x.priority === 'HIGH').map((x) => x.id)
		if(highComunicationIds.length > 0) {

			// Don't show up if there is another banned of update-cache (Since it goes first)
			const cacheCleaner = document.querySelector("#cache_warning");
			if (cacheCleaner)
				return;

			document.querySelector("#communications-alert").setAttribute('communication_ids', highComunicationIds.join(','));
			document.querySelector("#communications-alert").classList.remove("d-none")

			// Execute first time for showing badge
			handleScroll()
			// Adding scroll behaviour to navbar
			window.addEventListener('scroll', handleScroll)
		}
	}


	const onCloseConnection = (event) => {
		console.log("[Comunication WSocket] Connection closed", event);
	}

	const onErrorConnection = (event) => {
		console.log("[Comunication WSocket] Connection error", event);
	}

	const onMessageReceived = (event) => {
		console.log("[Comunication WSocket] Message received", event);

		updateComunicationBadge(JSON.parse(event.data));
		updateComunicationPopup(JSON.parse(event.data));
	}

	// Get the notification AWS environment from hostname resolution
	const getEnvironment = () => {
		if (['localhost', '127.0.0.1', '0.0.0.0'].filter(
			(localhost_like_str) => window.location.hostname.includes(localhost_like_str)
		).length > 0){
			return 'develop'
		}
		// Else is not a local one, so it must be a remote one
		if (window.location.hostname.includes('-dev.m2d.tech')){
			return 'develop'
		} else if (['-acc.m2d.tech', '-demo.m2d.tech'].some(substring => window.location.hostname.includes(substring))) {
			return 'acceptance'
		} else {
			return 'production'
		}
	}

	const settingNotifications = async () => {
		try {
			if (!appInfo.notificationEndPoint)
				return;
			// Return resolve
			const accessToken = JSON.parse(localStorage.getItem('accessToken'))
			const webSocketUrl = `${appInfo.notificationEndPoint}/${getEnvironment()}`
			const ws = new WebSocket(`${webSocketUrl}?Authorization=${accessToken}`);

			ws.onopen = onOpenConnection
			ws.onclose = onCloseConnection
			ws.onmessage = onMessageReceived
			ws.onerror = onErrorConnection


		} catch (error) {
			console.error('Error registering AWS:', error);
		}
	};

	React.useEffect(async () => {
		if (!authStorage || !authStorage.userData)
			return;

		settingNotifications()

	}, [authStorage])

	React.useEffect(() => {
		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	const handleViewDetails = () => {
        const communicationIdsString = document.querySelector("#communications-alert")?.getAttribute('communication_ids');
        const highComunication = communicationIdsString ? communicationIdsString.split(',') : [];
        const url = highComunication.length > 1 ? "/comunications?table_state=communications" : `/comunications/view/${highComunication[0]}`;
        window.location.href = url;
    };


	return (
		<Fragment>
			<div
				id={"communications-alert"}
				communication_ids=""
				color={""}
				className={`text-danger w-100 text-center d-none`}
				style={{
					zIndex: 1005,
					height: 50,
					fontFamily: 'Montserrat',
					padding: '0.5rem',
					background: '#ffd5d5'
				}}
			>
				<span className={""}>{!responsiveMaxWidth ? t("You have urgent communications to read") : t("Urgent communications")}</span>
				<Button
					outline
					onClick={handleViewDetails}
					color={'primary'}
					size={'sm'}
					className={'ms-1'}
				>
					<ExternalLink size={15} style={{marginRight: !responsiveMaxWidth ? '.4rem' : null}}/>
					{!responsiveMaxWidth ? <span className={"mb-0"}>{t("View Details")}</span> : null}
				</Button>
			</div>
		</Fragment>
	)
}

export default AwsNotification;
